var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 38h-4v-4h4v4zm-4-14h-4v10h4V24zm16-4h-4v8h4v-8zm-4-4h-4v4h4v-4zm-24 4H6v4h4v-4zm-4-4H2v4h4v-4zM20 6h4V2h-4v4zM5 5v6h6V5H5zm9 9H2V2h12v12zM5 29v6h6v-6H5zm9 9H2V26h12v12zM29 5v6h6V5h-6zm9 9H26V2h12v12zm-4 20v-6h-8v4h4v6h8v-4h-4zm-4-14h-8v4h8v-4zm-8-4H10v4h4v4h4v-4h4v-4zm2-2v-4h-4V6h-4v8h8zM9.5 6.5h-3v3h3v-3zm0 24h-3v3h3v-3zm24-24h-3v3h3v-3z"
  })));
}
export default SvgQrCode;